import { useState, useCallback, useRef } from "react";

import { fetchSearchRemoteSuggestion } from "../service";
import { createSearchHistoryManager } from "helpers/searchHistory";

const transObject = (params) => {
  const result = {};
  params.forEach((e, index) => {
    result[`query_histories[${index}]`] = e;
  });
  return result;
};

export const useSuggest = () => {
  const textRef = useRef("");
  const [suggestionList, setSuggestionList] = useState([]);
  const { addSearchHistory, getSearchHistory } = createSearchHistoryManager();

  const handleSuggestionSearch = useCallback((val) => {
    textRef.current = val;
    const searchHistories = getSearchHistory();
    const qs = transObject(searchHistories);
    fetchSearchRemoteSuggestion({ size: 5, query: val, ...qs }).then((result) => {
      const searchItems = result?.items || [];
      const hotSearchItems = (result?.hot_search?.items || []).map((item) => ({
        ...item,
        source: result?.hot_search?.source
      }));
      const items = searchItems.length ? searchItems : [...hotSearchItems, ...searchHistories];
      setSuggestionList(items);
    });
  }, []);

  return [suggestionList, handleSuggestionSearch, addSearchHistory, setSuggestionList];
};
